import { useState } from "react";
import { IDropdownProps } from "../../properties/DropdownProperties";
import useAnchoredMenu from "../../hooks/useAnchoredMenu";

const MediaDropdown = ({ id, answer, optionList }: IDropdownProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  // Outside click / Escape close it; near the bottom of the activity card it
  // opens upward and scrolls into view (see the hook).
  const {
    anchorRef: dropdownRef,
    menuRef,
    openUp,
  } = useAnchoredMenu<HTMLDivElement, HTMLUListElement>(showDropdown, () =>
    setShowDropdown(false),
  );

  const handleToggleDropdown = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
    setShowDropdown((prev) => !prev);
  };

  const handleOptionClick = (
    option: any,
    e: React.MouseEvent | React.TouchEvent
  ) => {
    e.stopPropagation();
    if (option.onClick) {
      option.onClick(e);
    }
    setShowDropdown(false);
  };

  return (
    <div key={id} ref={dropdownRef} className="mdd-wrap">
      <div className="mdd-trigger" onClick={handleToggleDropdown}>
        {answer}
      </div>
      <ul
        ref={menuRef}
        className={`mdd-menu ${
          showDropdown ? "mdd-menu-open" : "mdd-menu-closed"
        }${openUp ? " mdd-menu-up" : ""}`}
      >
        {optionList.map((option: any, index: number) => (
          <li
            key={option.id}
            className={`${
              option.listItemClassNames ? option.listItemClassNames : ""
            }`}
          >
            <div
              className={`mdd-item ${
                option.divClassNames ? option.divClassNames : ""
              }`}
              onClick={(e) => handleOptionClick(option, e)}
            >
              {option.media}
            </div>
            {index !== optionList.length - 1 ? (
              <div className="mdd-divider" />
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MediaDropdown;
